import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: BACKEND_URL ? `${BACKEND_URL}/api` : undefined, withCredentials: true });

export const imgSrc = (src) => {
  if (!src) return "";
  if (src.startsWith("/api/")) return `${BACKEND_URL}${src}`;
  return src;
};

export const fetchProducts = async (store) => {
  if (!BACKEND_URL) return [];
  try {
    const res = await api.get("/products", { params: { store } });
    return Array.isArray(res.data) ? res.data : [];
  } catch {
    return [];
  }
};

export const fetchPlans = async () => {
  if (!BACKEND_URL) return [];
  try {
    const res = await api.get("/plans");
    return Array.isArray(res.data) ? res.data : [];
  } catch {
    return [];
  }
};

export const formatApiError = (detail) => {
  if (detail == null) return "Algo deu errado. Tente novamente.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (typeof e?.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (typeof detail?.msg === "string") return detail.msg;
  return String(detail);
};
